import { communicationService, eventsRepository } from '@ad-engine/communication';
import { utils } from '../index';

class AssetLoader {
	loadPixel(pixelUrl: string, logGroup: string): void {
		const element = document.createElement('img');
		element.src = pixelUrl;

		element.onload = () => {
			utils.logger(logGroup, 'pixel loaded');
			communicationService.emit(eventsRepository.PARTNER_LOAD_STATUS, {
				status: logGroup + '_loaded',
			});
		};

		document.body.appendChild(element);
	}
}

export const assetLoader = new AssetLoader();
